<div>
  <i
    (click)="returnToManageCommissions()"
    class="fa-solid fa-circle-arrow-left back-icon float-start cursor-pointer"
    title="Back to Manage Commissions Page">
  </i>
</div>
<div class="page-header-bar">
  <section class="account-signatures">
    <h2>Account Signatures</h2>
    <div class="account-signatures--btn-container">
      <button
        type="button"
        class="btn-secondary action-btn action-btn"
        (click)="downloadSignatureTemplate()"
      >
        <svg
          aria-hidden="true"
          focusable="false"
          fill="none"
          height="19"
          viewBox="0 0 20 19"
          width="20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.74312 14.7562L8.74377 17.7575M8.74377 17.7575L11.7456 14.7574M8.74377 17.7575L8.74507 10.7545M2.74187 12.0557C0.69274 10.0606 0.165375 6.971 1.43665 4.40907C2.70792 1.84714 5.48726 0.398405 8.3155 0.823468C11.1437 1.24853 13.3744 3.45023 13.8365 6.27267C13.9766 6.26271 14.1066 6.25266 14.2467 6.25266C16.6337 6.24635 18.6084 8.10886 18.7415 10.4922C18.8747 12.8755 17.1197 14.9464 14.7469 15.206"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            stroke="#111111"
          />
        </svg>
        Download Signature Template
      </button>
      <button
        class="btn-primary action-btn filter-btn"
        data-backdrop="static"
        data-keyboard="false"
        (click)="openAddAccountSignatureModal()"
      >
        + Add Signature
      </button>
    </div>
  </section>
  <div>View and manage your active Account Signatures</div>
</div>
<div>
  <div class="signatures">
    @for (accountSignature of signatures(); track accountSignature; let i = $index) {
      <div>
        <mat-card>
          <mat-card-header>
            <section class="accountSignature-image-container">
                <img
                  alt="Account Signature '{{ accountSignature.name }}'"
                  class="accountSignature-image"
                  [src]="
                    getSanitizedImage(
                      accountSignature.signatureImageBase64,
                      accountSignature.imageType
                    )
                  "
                />
              </section>
            </mat-card-header>
            <mat-card-content>
              <div class="headline">
                <span class="bold">Signature Name:</span> {{accountSignature.name}}
              </div>
            </mat-card-content>
            <mat-card-footer>
              <mat-card-actions align="end">
                @if (!accountSignature.commissionGuid) {
                  <button
                    (click)="deleteConfirmationDialog(accountSignature)"
                    class="btn-secondary">
                    Delete
                  </button>
                }
                <button (click)="openEditAccountSignatureModal(accountSignature)"
                  class="btn-primary hide">
                  Edit
                </button>
              </mat-card-actions>
            </mat-card-footer>
          </mat-card>
        </div>
      }
    </div>
  </div>
